export const promotions = [
  {
    id: 1,
    title: "Pastel de Tres Leches",
    subtitle: "El clásico mexicano que enamora",
    description: "Esponjoso, cremoso y lleno de sabor. Perfecto para cualquier celebración.",
    badge: "PROMOCIÓN ESPECIAL",
    discount: "20% OFF",
    image: "https://readdy.ai/api/search-image?query=beautiful%20tres%20leches%20cake%20with%20whipped%20cream%20and%20strawberries%20on%20top%2C%20rustic%20wooden%20table%2C%20warm%20lighting%2C%20mexican%20bakery%20style%2C%20soft%20pastel%20background%2C%20professional%20food%20photography%2C%20elegant%20presentation%2C%20creamy%20texture%2C%20garnished%20with%20fresh%20fruits&width=1440&height=800&seq=promo1&orientation=landscape",
    cta: "Ver Producto",
    productId: 4,
  },
  {
    id: 2,
    title: "Galletas Artesanales",
    subtitle: "Hechas con amor y tradición",
    description: "Variedad de sabores únicos elaboradas con ingredientes 100% mexicanos.",
    badge: "NUEVO",
    discount: "2x1 Hoy",
    image: "https://readdy.ai/api/search-image?query=assorted%20artisan%20cookies%20on%20rustic%20wooden%20board%2C%20colorful%20decorated%20sugar%20cookies%2C%20chocolate%20chip%20cookies%2C%20warm%20bakery%20atmosphere%2C%20mexican%20artisan%20style%2C%20soft%20cream%20background%2C%20professional%20food%20photography%2C%20beautiful%20arrangement&width=1440&height=800&seq=promo2&orientation=landscape",
    cta: "Ver Producto",
    productId: 9,
  },
  {
    id: 3,
    title: "Helados Artesanales",
    subtitle: "Sabores que refrescan el alma",
    description: "Elaborados con frutas frescas de temporada. ¡Prueba nuestros sabores únicos!",
    badge: "TEMPORADA",
    discount: "3 x $150",
    image: "https://readdy.ai/api/search-image?query=colorful%20artisan%20ice%20cream%20scoops%20in%20waffle%20cones%2C%20vibrant%20tropical%20flavors%2C%20mango%20strawberry%20vanilla%2C%20mexican%20style%2C%20bright%20cheerful%20background%2C%20professional%20food%20photography%2C%20fresh%20ingredients%2C%20beautiful%20presentation&width=1440&height=800&seq=promo3&orientation=landscape",
    cta: "Ver Producto",
    productId: 12,
  },
];

export const categories = [
  {
    id: 1,
    name: "Pasteles Grandes",
    icon: "ri-cake-3-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/c16d4f1ab98e2871719ba0ee0ef58f08.jpeg",
    count: 6,
    priority: 1,
  },
  {
    id: 2,
    name: "Pasteles Medianos",
    icon: "ri-cake-2-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/482e13339d716515b45c1730c2e49b19.png",
    count: 8,
    priority: 2,
  },
  {
    id: 3,
    name: "Pasteles Individuales",
    icon: "ri-cake-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/312982eee3e8e73a293cb104555d4a56.png",
    count: 12,
    priority: 3,
  },
  {
    id: 4,
    name: "Galletas",
    icon: "ri-restaurant-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/94d974cbb89535b901b85948dd3f8e02.png",
    count: 20,
    priority: 4,
  },
  {
    id: 5,
    name: "Gelatinas",
    icon: "ri-drop-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/487cf951c89278b7807f5009ec60a8b9.jpeg",
    count: 8,
    priority: 5,
  },
  {
    id: 6,
    name: "Panqués y Roscas",
    icon: "ri-donut-chart-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/4d68406401505a5aa4cb4cbee00d257c.jpeg",
    count: 7,
    priority: 6,
  },
  {
    id: 7,
    name: "Tartas",
    icon: "ri-pie-chart-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/4f78c047beca3f5b9764203bceed5a87.jpeg",
    count: 5,
    priority: 7,
  },
  {
    id: 8,
    name: "Sin Azúcar",
    icon: "ri-heart-pulse-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/ccf29f570c544f81dd5a24a9b67e6926.jpeg",
    count: 9,
    priority: 8,
  },
  {
    id: 9,
    name: "Productos para perrito",
    icon: "ri-bear-smile-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/7863af60738e93df6d61594986061207.jpeg",
    count: 6,
    priority: 9,
  },
  {
    id: 10,
    name: "Helados",
    icon: "ri-goblet-line",
    image: "https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/6cfdcde9bf0d3842bdbfde8fb5bdec2e.jpeg",
    count: 10,
    priority: 10,
  },
];

export const blogPreviews = [
  {
    id: 1,
    title: "5 Secretos para el Pastel Perfecto",
    category: "Consejos",
    image: "https://readdy.ai/api/search-image?query=pastry%20chef%20decorating%20cake%20in%20professional%20kitchen%2C%20artisan%20baking%2C%20warm%20lighting%2C%20mexican%20bakery%2C%20professional%20food%20photography%2C%20cream%20and%20pink%20tones%2C%20beautiful%20workspace&width=600&height=400&seq=blog1&orientation=landscape",
    date: "15 Abr 2026",
  },
  {
    id: 2,
    title: "Historia de San7as Huellitas",
    category: "Causas Sociales",
    image: "https://readdy.ai/api/search-image?query=happy%20rescued%20dogs%20in%20shelter%2C%20cute%20puppies%2C%20warm%20lighting%2C%20adoption%20center%2C%20cheerful%20atmosphere%2C%20colorful%20background%2C%20professional%20photography%2C%20heartwarming%20scene&width=600&height=400&seq=blog2&orientation=landscape",
    date: "10 Abr 2026",
  },
  {
    id: 3,
    title: "Ingredientes 100% Mexicanos",
    category: "Noticias",
    image: "https://readdy.ai/api/search-image?query=fresh%20mexican%20ingredients%20for%20baking%2C%20vanilla%2C%20cacao%2C%20fruits%2C%20colorful%20market%2C%20rustic%20wooden%20table%2C%20warm%20lighting%2C%20professional%20food%20photography%2C%20vibrant%20colors%2C%20artisan%20style&width=600&height=400&seq=blog3&orientation=landscape",
    date: "5 Abr 2026",
  },
  {
    id: 4,
    title: "Tendencias en Repostería 2026",
    category: "Tendencias",
    image: "https://readdy.ai/api/search-image?query=modern%20trendy%20cake%20designs%202026%2C%20minimalist%20elegant%20cakes%2C%20pastel%20colors%2C%20floral%20decorations%2C%20professional%20food%20photography%2C%20beautiful%20presentation%2C%20contemporary%20bakery%20style&width=600&height=400&seq=blog4&orientation=landscape",
    date: "1 Abr 2026",
  },
];

export const featuredProducts = [
  {
    id: 1,
    name: "Pastel Red Velvet",
    category: "Pasteles Medianos",
    price: 380,
    description: "Terciopelo rojo con crema de queso, decorado con frutos rojos frescos.",
    image: "https://readdy.ai/api/search-image?query=red%20velvet%20cake%20with%20cream%20cheese%20frosting%20and%20fresh%20berries%2C%20elegant%20presentation%2C%20cream%20background%2C%20professional%20food%20photography%2C%20mexican%20bakery%2C%20beautiful%20slice%20visible&width=400&height=300&seq=feat1&orientation=landscape",
    badge: "FAVORITO",
    menuProductId: 5,
  },
  {
    id: 2,
    name: "Galletas de Mantequilla",
    category: "Galletas",
    price: 85,
    description: "Docena de galletas artesanales con chispas de chocolate belga.",
    image: "https://readdy.ai/api/search-image?query=butter%20cookies%20with%20chocolate%20chips%20on%20rustic%20board%2C%20golden%20brown%2C%20warm%20bakery%20atmosphere%2C%20cream%20background%2C%20professional%20food%20photography%2C%20artisan%20style%2C%20dozen%20cookies&width=400&height=300&seq=feat2&orientation=landscape",
    badge: "NUEVO",
    menuProductId: 9,
  },
  {
    id: 3,
    name: "Helado de Mango",
    category: "Helados",
    price: 65,
    description: "Helado artesanal de mango Ataulfo con toque de chile y limón.",
    image: "https://readdy.ai/api/search-image?query=mango%20artisan%20ice%20cream%20scoop%20in%20waffle%20cone%2C%20vibrant%20orange%20color%2C%20tropical%20style%2C%20bright%20background%2C%20professional%20food%20photography%2C%20fresh%20mango%20pieces%2C%20mexican%20flavor&width=400&height=300&seq=feat3&orientation=landscape",
    badge: "TEMPORADA",
    menuProductId: 12,
  },
  {
    id: 4,
    name: "Pastel de Cumpleaños",
    category: "Pasteles Grandes",
    price: 650,
    description: "Pastel personalizado para tu celebración especial, 3 pisos.",
    image: "https://readdy.ai/api/search-image?query=beautiful%20birthday%20cake%20with%20colorful%20decorations%20and%20candles%2C%20festive%20presentation%2C%20cream%20background%2C%20professional%20food%20photography%2C%20mexican%20bakery%2C%20elegant%20design%2C%20celebration&width=400&height=300&seq=feat4&orientation=landscape",
    badge: "PERSONALIZABLE",
    menuProductId: 8,
  },
];
